export const environment = {
    production: true,
    webpackDevServerPort: null // Not relevant for prod
};